import { EAction } from '~/src/features/tariffBuilder/constants/actions';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';
import { IAction } from '~/src/store';

type TAddEntityArgs = {
    entity: EEntity,
    group: string,
    key: number,
}

const removeTvEntity = ({ entity, group, key }: TAddEntityArgs): IAction<EAction.RemoveTvEntity, TAddEntityArgs> => ({
    type: EAction.RemoveTvEntity,
    payload: {
        entity,
        group,
        key,
    },
});

export default removeTvEntity;
